var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPiercingAndTattoos = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Love-Heart-Arrow--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Love Heart Arrow Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.86 7.2a0.52 0.52 0 0 0 0.19 -0.36 0.54 0.54 0 0 0 -0.15 -0.38l-0.79 -0.79A0.53 0.53 0 0 1 7 5.34L6.86 3.5a2.55 2.55 0 0 0 -0.69 -1.6L4.45 0.15A0.49 0.49 0 0 0 3.93 0a0.49 0.49 0 0 0 -0.33 0.44l-0.3 2.42a0.51 0.51 0 0 1 -0.44 0.44l-2.42 0.3a0.51 0.51 0 0 0 -0.44 0.34 0.51 0.51 0 0 0 0.14 0.52l1.8 1.68a2.43 2.43 0 0 0 1.59 0.69l1.84 0.1a0.48 0.48 0 0 1 0.32 0.15l0.78 0.78a0.47 0.47 0 0 0 0.37 0.14 0.48 0.48 0 0 0 0.36 -0.16 5 5 0 0 1 0.66 -0.64Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.32 20.05a0.49 0.49 0 0 0 -0.84 -0.25l-0.27 0.26a0.5 0.5 0 0 1 -0.71 0l-2.25 -2.25a0.49 0.49 0 0 1 0 -0.69c1.42 -1.55 2.63 -3.36 2.63 -5.05a4.31 4.31 0 0 0 -3.36 -4.5 3.73 3.73 0 0 0 -3.62 1.29 0.51 0.51 0 0 1 -0.76 0 3.73 3.73 0 0 0 -3.62 -1.29 4.31 4.31 0 0 0 -3.36 4.5c0 4 6.79 8.69 7.08 8.89a0.48 0.48 0 0 0 0.56 0c0.07 -0.05 0.48 -0.33 1.07 -0.79a0.49 0.49 0 0 0 0.05 -0.75l-1.85 -1.85a0.75 0.75 0 1 1 1.06 -1.06l5 5a0.48 0.48 0 0 1 0 0.7l-0.29 0.3a0.5 0.5 0 0 0 0.25 0.84l3.31 0.65a0.5 0.5 0 0 0 0.6 -0.6Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPiercingAndTattoos);
export default ForwardRef;